import { AbstractProductDataCommand } from "./abstractProductDataCommand";

export class GlobalEntitiesCommand extends AbstractProductDataCommand {
  classNames: Array<string> = new Array<string>();
}